const VehicleHeader = () => {
  const buttons = document.querySelectorAll('.js-vehicleHeader-trigger');

  if (buttons.length > 0) {
    Array.from(buttons).forEach((button) => {
      button.addEventListener('click', (e) => {
        button.closest('.js-vehicleHeader-text')?.classList.toggle('-more');
      });
    });
  }
};

export default VehicleHeader;
